import { render, staticRenderFns } from "./Archives.vue?vue&type=template&id=511ec4ee&scoped=true&"
import script from "./Archives.vue?vue&type=script&lang=ts&"
export * from "./Archives.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511ec4ee",
  null
  
)

export default component.exports